import React, { useState, useEffect } from 'react';
import { jwtDecode } from 'jwt-decode';
import { useHistory } from 'react-router-dom';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import IconButton from '@mui/material/IconButton';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import ArrowForward from '@mui/icons-material/ArrowForward';
import ActivateIcon from '@mui/icons-material/CheckCircle';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { fetchData, deleteData, activateData, postData, updateData, masterdataindex } from '../../../apiService';
import { Link } from 'react-router-dom';
import { useAuth } from '../../../AuthContext';
import { tokenIsExpired } from '../../../authUtils';
import Button from '@mui/material/Button';
import Select from 'react-select';
import ExitToAppIcon from '@mui/icons-material/ExitToApp';
import CancelIcon from '@mui/icons-material/Cancel';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { Tooltip } from '@mui/material';
import CircularProgress from '@mui/material/CircularProgress';
import AddIcon from '@mui/icons-material/Add';

function CategoryIndex() {
    const [data, setData] = useState([]);
    const [deleteItemId, setDeleteItemId] = useState(null);
    const [confirmDialogOpen, setConfirmDialogOpen] = useState(false);
    const [searchTerm, setSearchTerm] = useState('');
    const [filteredData, setFilteredData] = useState([]);
    const [isModalOpen, setIsModalOpen] = useState(false);  // Modal state

    const [name, setName] = useState("");
    const [TaxRate, setTaxRate] = useState("");
    const [hsncode, setHSNCode] = useState("");

    const history = useHistory();
    const { isAuthenticated, companyId, permissions, userId, token, logout } = useAuth();
    const hasCreateMasterPermission = permissions.includes('Create Master');
    const hasEditMasterPermission = permissions.includes('Edit Master');
    const hasDeleteMasterPermission = permissions.includes('Delete Master');
    const [loading, setLoading] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [successMessage, setSuccessMessage] = useState("");
    const [errorMessage, setErrorMessage] = useState("");

    useEffect(() => {
        if (isAuthenticated && tokenIsExpired(token)) {
            logout();

            return;
        }
        // Token is not expired, fetch data
        fetchtableData();
        setLoading(true);
    }, [isAuthenticated, companyId, userId, token, logout]);

    useEffect(() => {
        if (searchTerm.trim() === '') {
            setFilteredData(data);
        } else {
            const filtered = data.filter(item => item.Name && item.Name.toLowerCase().includes(searchTerm.toLowerCase()));
            setFilteredData(filtered);
        }
    }, [data, searchTerm]);

    const fetchtableData = async () => {
        setLoading(true);
        fetchData('ItemCategoryApi', `/${companyId}`, token)
            .then((response) => {
                if (response.responseCode === '1111') {
                    setData(response.response_data);
                    setFilteredData(response.response_data);

                }
                console.log(response);
            })

            .catch((error) => {
                console.error('Error fetching Item Category:', error);
                // Handle error, e.g., redirect to login if token is expired
                if (error.response && error.response.status === 401) {
                    logout();
                    // Redirect to login with the current location as a parameter
                    history.replace(`/login?redirect=${encodeURIComponent(window.location.pathname)}`);
                }
            })
            .finally(() => {
                setLoading(false); // Hide loading screen
            });
    };

    const handleDelete = async () => {
        deleteData('ItemCategoryApi', `${deleteItemId}`, token)
            .then((response) => {
                setDeleteItemId(null);
                setConfirmDialogOpen(false);
            })
            .catch((error) => {
                console.error('Error deleting record:', error);
            });
    };

    const handleActivate = (itemId) => {
        activateData('ItemCategoryApi', `${itemId}`)
            .then(() => {
                // Fetch table data or update state
            })
            .catch((error) => {
                console.error('Error activating record:', error);
            });
    };

    const openConfirmDialog = (itemId) => {
        setDeleteItemId(itemId);
        setConfirmDialogOpen(true);
    };

    const closeConfirmDialog = () => {
        setDeleteItemId(null);
        setConfirmDialogOpen(false);
    };

    const toggleModal = () => {
        setIsModalOpen(!isModalOpen);
    };


    const checkDuplicate = async () => {
        const response = await fetchData('ItemCategoryApi', `/${companyId}`, token);
        if (response.responseCode === '1111') {
            const existingData = response.response_data;
            return existingData.some(item => item.Name.toLowerCase() === name.toLowerCase());
        }
        return false;
    };

    const addRecord = async (e) => {
        e.preventDefault();
        const isDuplicate = await checkDuplicate();
        if (isDuplicate) {
            alert('Item with the same Name already exists.');
            return;

        }

        const CreateData = {
            Name: name,
            TaxRate: TaxRate,
            HSNCode: hsncode,
            CreatedBy: userId,
            CompanyId: companyId,
            CreatedDate: new Date(),
        };

        postData('ItemCategoryApi', CreateData, token)
            .then((response) => {
                console.log('Item Category Created successfully:', response);
                setSuccessMessage("Item Category Created successfully!");
                setErrorMessage("");
                setName('');
                setTaxRate('');
                setHSNCode('');
                setIsModalOpen(false);
                window.location.reload();
                setTimeout(() => {
                    setSuccessMessage("");
                }, 3000);
            })
            .catch((error) => {
                console.error('Item Create error:', error);
                setIsLoading(false);
            });
    };


    //EDIT
    const [isDetailModalOpen, setIsDetailModalOpen] = useState(false);

    const openDetailModal = async (id) => {
        try {
            const response = await fetchData('ItemCategoryApi', `/CategoryDetails/${id}`, token);
            if (response.responseCode === '1111') {
                setUpdateData(response.response_data);
                setIsDetailModalOpen(true);
            }
        } catch (error) {
            console.error('Error fetching Item Details:', error);
        }
    };

    const toggleModalBranch = () => {
        setIsDetailModalOpen(false); // Step 2
    };

    const handleUpdateInputChange = (event) => {
        const { name, value } = event.target;
        setUpdateData((prevDataItem) => ({
            ...prevDataItem,
            [name]: value,
        }));
    };

    const [updatedData, setUpdateData] = useState({});


    const updateRecord = async (event) => {
        event.preventDefault();

        try {

            await updateData('ItemCategoryApi', `${updatedData.Id}`, updatedData, token);
            setUpdateData({
                CompanyId: companyId,
                Name: '',
            });
            //fetchtableData();
            setIsDetailModalOpen(false);
            fetchtableData();
        } catch (error) {
            console.error('Error updating record:', error);
        }
    };


    return (
        <div className="w-full max-w-sm container mt-2 mx-auto">
            <div className='w-full mb-2 flex'>
                <h6 className='productHead flex-grow linkcolor' style={{ fontFamily: 'Georgia, Cambria, "Times New Roman", Times, serif', color: 'black' }}>ITEM CATEGORY</h6>
                <div className='w-1/4 mb-2 flex'>
                    <input
                        type="text"
                        placeholder="Search..."
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                        className="search-input shadow border rounded py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                    />
                </div>
                
                {hasCreateMasterPermission && (
                    <Tooltip title="Category Registration">
                        <Button
                            style={{ height: '30px', marginLeft: '10px', marginTop: '10px' }}
                            component={Link}
                            onClick={toggleModal}
                            className="relative inline-block px-4 py-2 text-lg font-medium text-purple-700 border-2 border-purple-700 rounded transition-colors duration-300 hover:text-white hover:bg-purple-700"
                        >
                            + ADD ITEM
                        </Button>
                    </Tooltip>
                )}

            </div>

            {isModalOpen && (
                <div className="fixed inset-0 flex items-center justify-center z-10">
                    <div className="bg-white p-6 rounded-lg shadow-lg" style={{ width: '900px' }}>
                        <h6 style={{ color: 'brown', textAlign: 'center', fontWeight: 'bolder' }}>ITEM CATEGORY CREATE</h6>
                        <div className="w-full mb-4 flex">
                            <div className="w-3/4 mr-2" >
                                <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="name">
                                    Name
                                </label>
                                <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                    type="text"
                                    name="Name"
                                    placeholder="Enter Name"
                                    value={name}
                                    onChange={(e) => setName(e.target.value)}
                                    onClick={(e) => e.target.select()}
                                />
                            </div>
                            <div className="w-1/4 mr-2" >
                                <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="name">
                                    Tax Rate
                                </label>
                                <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                    type="number"
                                    name="TaxRate"
                                    placeholder="Enter Tax Rate"
                                    value={TaxRate}
                                    onChange={(e) => setTaxRate(e.target.value)}
                                    onClick={(e) => e.target.select()}
                                />
                            </div>

                            <div className="w-1/4 mr-2" >
                                <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="name">
                                    HSN Code
                                </label>
                                <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                    type="text"
                                    name="HSNCode"
                                    placeholder="Enter HSN Code"
                                    value={hsncode}
                                    onChange={(e) => setHSNCode(e.target.value)}
                                    onClick={(e) => e.target.select()}
                                />
                            </div>
                        </div>

                        <div className="w-1/2 mr-4" style={{ marginTop: '23px' }}>
                            <button className="bg-green-500 text-white px-4 py-2 rounded" onClick={addRecord}>
                                Add Record
                            </button>
                            <button className="bg-blue-500 text-white px-4 py-2 rounded ml-2" onClick={toggleModal}>
                                Cancel
                            </button>
                        </div>
                    </div>
                </div>
            )}


            <div className='mb-2 flex' style={{ maxHeight: '520px', overflowY: 'auto' }}>
                <TableContainer component={Paper}>
                    <Table stickyHeader>
                        <TableHead>
                            <TableRow>
                                <TableCell>Sl.No</TableCell>
                                <TableCell>Category</TableCell>
                                <TableCell>HSN Code</TableCell>
                                <TableCell>Tax Rate</TableCell>
                                <TableCell>Actions</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {filteredData && filteredData.map((item, index) => (
                                <TableRow key={item.Id} className={item.IsActive ? '' : 'inactiveRow'}>
                                    <TableCell>{index + 1}</TableCell>
                                    <TableCell>{item.Name}</TableCell>
                                    <TableCell>{item.HSNCode}</TableCell>
                                    <TableCell>{item.TaxRate}</TableCell>
                                    <TableCell
                                        sx={{
                                            borderBottom: '1px solid #FFE1E2',
                                            height: '40px',
                                            padding: '5px',
                                            color: 'black',
                                            width: '15%',
                                            textAlign: 'right',
                                        }}
                                    >
                                        {hasEditMasterPermission && (
                                            <IconButton onClick={() => openDetailModal(item.Id)}>
                                                <EditIcon style={{ color: 'blueviolet' }} />
                                            </IconButton>
                                        )}
                                        {hasDeleteMasterPermission && (
                                            <IconButton onClick={() => openConfirmDialog(item.Id)}>
                                                <DeleteIcon style={{ color: 'brown' }} />
                                            </IconButton>
                                        )}
                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                        <Dialog
                            open={confirmDialogOpen}
                            onClose={closeConfirmDialog}
                            aria-labelledby="alert-dialog-title"
                            aria-describedby="alert-dialog-description"
                        >
                            <DialogTitle id="alert-dialog-title">{"Delete Record?"}</DialogTitle>
                            <DialogContent>
                                <DialogContentText id="alert-dialog-description">
                                    Are you sure you want to delete this record?
                                </DialogContentText>
                            </DialogContent>

                            <DialogActions>
                                <button onClick={closeConfirmDialog} className="bg-red-600 text-white border border-red-600 rounded px-4 py-2 mr-2">
                                    Cancel
                                </button>
                                <button onClick={handleDelete} className="bg-green-600 text-white border border-green-600 rounded px-4 py-2">
                                    Confirm
                                </button>
                            </DialogActions>
                        </Dialog>
                    </Table>
                </TableContainer>
                {isDetailModalOpen && (
                    <div className="fixed inset-0 flex items-center justify-center z-10">
                        <div className="bg-white p-6 rounded-lg shadow-lg" style={{ width: '900px' }}>
                            <h6 style={{ color: 'brown', textAlign: 'center', fontWeight: 'bolder' }}>BALANCE SHEET CREATE</h6>
                            <div className="w-full mb-4 flex">
                                <div className="w-3/4 mr-2">
                                    <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="name">
                                        Name
                                    </label>
                                    <input
                                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                        type="text"
                                        name="Name"
                                        placeholder="Enter name"
                                        value={updatedData.Name}
                                        onChange={handleUpdateInputChange}
                                        onClick={(e) => e.target.select()}

                                    />
                                </div>

                                <div className="w-1/4 mr-2">
                                    <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="name">
                                        Tax Rate
                                    </label>
                                    <input
                                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                        type="number"
                                        name="TaxRate"
                                        placeholder="Enter Tax Rate"
                                        value={updatedData.TaxRate}
                                        onChange={handleUpdateInputChange}
                                        onClick={(e) => e.target.select()}

                                    />
                                </div>

                                <div className="w-1/4 mr-2">
                                    <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="name">
                                        HSN Code
                                    </label>
                                    <input
                                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                        type="text"
                                        name="HSNCode"
                                        placeholder="Enter HSN Code"
                                        value={updatedData.HSNCode}
                                        onChange={handleUpdateInputChange}
                                        onClick={(e) => e.target.select()}

                                    />
                                </div>

                            </div>

                            <div className="w-1/2 mr-4" style={{ marginTop: '23px' }}>
                                <button className="bg-green-500 text-white px-4 py-2 rounded" onClick={updateRecord}>
                                    Update Record
                                </button>
                                <button className="bg-blue-500 text-white px-4 py-2 rounded ml-2" onClick={toggleModalBranch}>
                                    Cancel
                                </button>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
}

export default CategoryIndex;
